import { Box, TextField } from '@mui/material';

import Send from '@/assets/icons/Send';
import Button from '@/components/Buttons/Button';
import { useChat } from '@/features/AIChat/context/useChat';

const MessageInput = ({ maxRows }: { maxRows: number }) => {
  const {
    inputMessage,
    setInputMessage,
    handleSend,
    isInitializing,
    isSending,
    conversationId,
    animatedText
  } = useChat();
  const disabled = !conversationId || isSending || isInitializing || !!animatedText;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: 'var(--GX-Main-Background, #070818)',
        borderTop: '1px solid var(--GX-Text-Disabled, #6C737A)'
      }}
    >
      <TextField
        fullWidth
        multiline
        maxRows={maxRows}
        placeholder='Enter your prompt...'
        sx={{
          height: '100%',
          padding: '16px',
          '& .MuiInputBase-input::placeholder': {
            color: '#FFF',
            opacity: 1
          },
          '& .MuiInputBase-root': {
            p: 0,
            height: '100%',
            display: 'block'
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              border: 'none'
            },
            '&.Mui-focused fieldset': {
              border: 'none'
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: 'none'
            }
          }
        }}
        value={inputMessage}
        onChange={e => {
          setInputMessage(e.target.value);
        }}
        onKeyDown={e => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (!disabled && inputMessage.trim()) {
              handleSend();
            }
          }
        }}
      />
      <Button
        color='primary'
        disabled={disabled || !inputMessage.trim()}
        sx={{
          width: '48px',
          minWidth: '48px',
          height: '108px',
          p: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          '&.Mui-disabled': {
            backgroundColor: 'var(--GX-action-bar-button-tile, rgba(248, 248, 248, 0.20))',
            color: 'var(--GX-Text, #F8F8F8);',
            opacity: 1
          }
        }}
        variant='contained'
        onClick={handleSend}
      >
        <Send sx={{ fontSize: '24px !important', m: '0 !important' }} />
      </Button>
    </Box>
  );
};

export default MessageInput;
